module.exports = __webpack_public_path__ + "e79c489e47751d680b2ae84b1b4b3a34.woff2";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/opensans-regular-webfont.woff2
// module id = 343
// module chunks = 0